import { getGeoValue, TGeoValue, TJsonQuery } from '../../../packages/JsonQuery';

export function removePolygonFromJsonQuery(jsonQuery: TJsonQuery): TGeoValue[] {
  const geo = getGeoValue()(jsonQuery);

  if (!geo) {
    return [];
  }

  const value = geo.filter(item => item.type !== 'polygon');

  return value.length === 0 ? [] : value;
}
